/* eslint-disable prefer-promise-reject-errors */
/**
 * Created by Stan on 02.02.2020.
 */
import Vue from 'vue'
import axios from '@/utils/api'
import FingerprintJS from '@fingerprintjs/fingerprintjs';
import Crezu from '@/utils/'
import { openLink } from './helpers/redirect-actions'
// show preloader
let confirmAttempts = 0
const handleConfirmError = (commit) => {
  confirmAttempts += 1
  if (confirmAttempts >= 3) commit('SHOW_SKIP_BUTTON', true)
}

export const nextStepPrepare = function ({ commit, state, getters, dispatch }, incr) {
  const currentField = state.history[state.currentStep]
  const country = state.additionalParams.country
  if (incr === 0) { return } // we already on target step
  if (!currentField.field || !currentField.field['game-type']) { return } // user click forward or backward buttons very fast
  if (currentField.name === 'name' || (currentField.field['game-type'] === 'three-fields')) {
    if (currentField.name === 'name') {
      localStorage.setItem('customerName', currentField.value || '')
      localStorage.setItem('customerSurname', state.history[state.currentStep + 1].value || '')
    }

    let flag = true
    for (const i in [...Array(3).keys()]) {
      const field = state.history[state.currentStep + +i]
      if (!field.isValid) {
        flag = false
        commit('UPDATE_FIELD', { customStep: state.currentStep + +i, isValid: false, showError: true })
      }
    }
    if (!flag && incr > 0) {
      dispatch('fieldReRender')
      return
    }
  }
  if (incr > 0) {
    if (!currentField.isValid) {
      console.log('invalid data', currentField.name, currentField.value)
      commit('UPDATE_FIELD', { isValid: false, showError: true })
      dispatch('fieldReRender')
      if (currentField.name === 'confirm') handleConfirmError(commit)
      return
    }
    if (['phone', 'loan_sum_repeat'].includes(currentField.name) && !state.additionalParams.is_terms_accepted) {
      commit('CHANGE_ADDITIONAL_PARAMS', { is_terms_accepted: '' })
      commit('UPDATE_FIELD', { showCheckboxError: true })
      dispatch('fieldReRender')
      return
    }
    if (currentField.name === 'knowed_offers') {
      dispatch('offersLinking')
      dispatch('pushGAEvent', 'lenderPickerCompleted')
    }
    if (Object.keys(state.history).length === state.currentStep + incr) {
      dispatch('getDataFromBackend', incr)
      return
    }
    if (currentField.name === 'province' && country === 1 && currentField.value) {
      dispatch('getEsCity', currentField.value)
      return
    }
    if (currentField.name === 'city' && country === 1 && currentField.value) {
      dispatch('getEsZip', currentField.value)
      return
    }
    if (currentField.name === 'zip' && country === 2) {
      dispatch('getMxColony', currentField.value)
      return
    }
    if (['zip', 'work_zip'].includes(currentField.name) && country === 14) {
      dispatch('getPlCity', { zip: currentField.value, prefix: currentField.name === 'work_zip' ? 'work_' : '' })
      return
    }
    // TODO: email replacer - delete or integrate
    // if (state.history[state.currentStep].name === 'email') {
    //   dispatch('checkEmailDomain', localStorage.getItem('domain'))
    // }
    if (currentField.name === 'phone' && state.flow === 'hybridAuth' && !window.hybridAuthAlreadySended) {
      dispatch('callSimpleAuth', incr)
      return
    }
  }
  // TODO: delete moneyman additional
  dispatch('sendCrezuEvent', { id: 24, data: { sub2: currentField.name, sub3: `${currentField.name}_completed` } })

  commit('SHOW_AUTH_TEXT', false)
  dispatch('changeStep', incr)
}

export const changeStep = function ({ commit, state, getters, dispatch }, incr) {
  // change step and insert field info
  let nextStep = state.history[state.currentStep + incr]
  if (!nextStep) {
    console.warn('can\'t change step, next is nothing')
    return
  }

  let nextOrder = state.currentStep + incr
  let temp = state.history

  // push new progressbar percents
  if (incr > 0 && !nextStep.skip && !nextStep.field) dispatch('pushPercents')

  // add step to datalayer event
  commit('UPDATE_FIELD_TIMING')
  commit('PUSH_FIELD_TO_DATALAYER', nextStep.name)

  if (nextStep.skip) {
    // case when next field is last and we need to skip it - so get new fields
    if (nextOrder === Object.keys(state.history).length - 1 && incr > 0) {
      dispatch('getDataFromBackend', incr + 1)
      return
    }
    // case when we go back and 0 step with status 'skip' - so we do nothing
    if (state.currentStep === 1 && incr < 0) return
    // in normal case we simply skip field
    dispatch('changeStep', incr + ((incr > 0) ? +1 : -1))
    return
  }
  const addFieldInfo = (step, skip) => {
    const name = temp[step].name
    let fieldInfo = getters.getFieldInfoByName(name)
    if (name.startsWith('agreements_')) {
      const nameWithoutPartner = name.split('_').splice(0,2).join('_')
      console.log('addFieldInfo for agreements:', nameWithoutPartner)
      fieldInfo = getters.getFieldInfoByName(nameWithoutPartner)
    }
    if (!fieldInfo) console.error(`FIELD ${name} NOT IN CONFIG`)
    Vue.set(temp[step], 'field', fieldInfo)
    if (skip) Vue.set(temp[step], 'skip', true)
  }
  const nextFieldTypeIsPreloader = temp[nextOrder].field && temp[nextOrder].field['game-type'] === 'preloader'
  // we don't need to rewrite field info if it exists (except preloader), because in Spain and Mexico
  // (for example) we add additionlal info to such fields like (cities, colonies etc.)
  if (!temp[nextOrder].field || nextFieldTypeIsPreloader) addFieldInfo(nextOrder, false)

  const fieldName = state.history[state.currentStep].name
  const nextFieldName = state.history[nextOrder].name
  commit('UPDATE_STEPS_CRO', { field: incr > 0 ? fieldName : nextFieldName, incr })
  if (incr > 0) {
    dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'groupSubmit', sub5: state.stepsCRO.length - 1, sub8: fieldName } })
  }
  dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'groupRender', sub5: state.stepsCRO.length, sub8: nextFieldName } })
  dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'fieldRender', sub5: nextFieldName, sub8: nextFieldName } })

  commit('CHANGE_HISTORY', temp)
  commit('CHANGE_STEP', nextOrder)
  dispatch('reRender')
}

export const processNextFields = function ({ commit, state, getters, dispatch }, data) {
  let newFields = []
  for (let i in state.fieldsOrdering) {
    if (data.fields.includes(state.fieldsOrdering[i])) newFields.push(state.fieldsOrdering[i])
  }

  // check for checkboxes. they are not in fieldsOrdering (ex. agreements_pl_pp) so we add it manually
  // data.fields.forEach(x => { if (x.startsWith('agreements_pl')) newFields.push(x) })
  data.fields.forEach(x => { if (x.startsWith('agreements_')) {
    if (state.additionalParams.country === 14 && getters.getFieldValue('loan_sum_repeat')) {
      console.log(`skip ${x} inserting because of previous loan_sum_repeat step`)
      return
    }
    console.log('PUSH agreements to data fields:', x)
    newFields.push(x)
  } })

  let i = 0
  newFields.map(x => {
    let historyStep = { name: x }
    if (['moneyman_agreements', 'prestamer_agreements'].includes(x)) {
      historyStep.skip = true
      historyStep.isValid = true
    }
    dispatch('insertOrUpdateField', {
      index: state.currentStep + data.incr + i,
      data: historyStep
    })
    i += 1
  })
  if (!newFields.length) {
    console.warn('requested fields not in config json -> go to feed')
    dispatch('successRedirectPrepare', 'Feed')
    dispatch('goToOffers')
    return
  }
  dispatch('nextStepPrepare', data.incr)
  commit('CHANGE_PRELOADER', false)
}

export const reRender = function ({ commit, state, dispatch }) {
  console.log('rerender triggered')
  let realType = state.history[state.currentStep].field['game-type']
  Vue.set(state.history[state.currentStep].field, 'game-type', null)
  setTimeout(function () {
    Vue.set(state.history[state.currentStep].field, 'game-type', realType)
    dispatch('scrollTo')
  }, 300)
}

export const fieldReRender = function ({ commit }) {
  commit('SHOW_INPUT_CHANGE_STATE', false)
  setTimeout(function () {
    commit('SHOW_INPUT_CHANGE_STATE', true)
  }, 1)
}

export const scrollTo = function ({ state }) {
  window.scrollTo(0, 0)
}

export const getDataFromBackend = function ({ commit, state, getters, dispatch }, incr) {
  console.log('GET DATA FROM BACKEND')
  commit('CHANGE_PRELOADER', true)
  //
  // prepare data to send
  let formData = new FormData()
  // fields for sending
  let currentRequestFields = []
  for (let i in state.history) {
    let field = state.history[i]
    // name can be empty in toProcess flow
    // if field has isSent flag - we will not send it in future
    if (field.name && !field.isSent && [
      'feed_manual_process',
      'knowed_offers',
      'moneyman_instantor',
      'moneyman_paylands',
      'moneyman_online_banking',
      'twinero_instantor',
      'welp_instantor'
    ].indexOf(field.name) === -1) {
      formData.set(field.name, field.value)
      currentRequestFields.push(field.name)
    }
    if (field.name === 'loan_period' && ([4, 5].indexOf(+state.additionalParams.country) > -1)) {
      formData.set(field.name, +field.value * 30)
    }
    if (field.name === 'interested_in_products') {
      formData.set(field.name, JSON.stringify(field.value))
    }
  }
  for (let j in state.additionalParams) {
    formData.set(j, state.additionalParams[j])
  }

  if (window.sendFLOnce) {
    formData.set('f_l', true)
    window.sendFLOnce = false // DONT SEND IT AGAIN
  }

  if (state.history[state.currentStep].name === 'confirm_email' && !Vue.prototype.$cookie.get('has_declined_confirm_email')) {
    commit('CHANGE_METHOD', '/confirm')
  } else {
    if (state.method === '/confirm') commit('CHANGE_METHOD', '/process')
  }

  const tf = Crezu.common.getURLParameter('tf') || Vue.prototype.$cookie.get('tf')
  const advertisingId = Crezu.common.getURLParameter('advertising_id')
  const appsflyerId = Crezu.common.getURLParameter('appsflyer_id')
  if (state.method === '/form') {
    if (tf) formData.set('tf', tf)
    if (advertisingId) formData.set('advertising_id', advertisingId)
    if (appsflyerId) formData.set('appsflyer_id', appsflyerId)
  }

  axios({
    method: 'POST',
    url: `${state.backendUrl}${state.method}` + (Vue.prototype.$cookie.get('has_declined_confirm_email') ? '?has_declined_confirm_email=1' : ''),
    data: formData,
    headers: {'Content-Type': 'application/json'}
  }).then((response) => {
    if (response.data.is_success) {
      // add isSent flag to sended fields for not sending in future requests
      dispatch('updateIsSentFieldsFlag', currentRequestFields)
      let res = response.data.data
      // set leadId
      commit('CHANGE_ADDITIONAL_PARAMS', { lead_id: res.lead_id })
      // update FCM token with actual leadId
      dispatch('updateFirebaseTokenWithLeadId')
      if (res.auth_token) {
        localStorage.setItem('auth_token', res.auth_token)
      }
      if (res.lead_status) {
        commit('CHANGE_LEAD_STATUS', res.lead_status)
      }
      if (state.method === '/process' && !window.applicationSubmitted) {
        dispatch('pushGAEvent', 'applicationSubmitted')
        window.applicationSubmitted = true
      } else if (state.method === '/form') {
        dispatch('pushGAEvent', { event: 'FirstStepSubmitted', state: 'new' })
        if (state.leadStatus === '1') dispatch('pushGAEvent', 'FirstStepSubmittedNew')
        dispatch('pushFBEvent', {
          track: 'track',
          event: 'Lead',
          data: { status: state.leadStatus }
        })
      }
      if (Crezu.common.getURLParameter('manual_process') && ['has_other_loans', 'other_loans_company'].indexOf(state.history[state.currentStep].name) > -1) {
        res.display = 'feed_manual_process'
      }

      // cards flow
      if (state.additionalParams.provider === '41') {
        window.onbeforeunload = null
        openLink('/feed_promo')
        return
      }

      let fields = res.fields
      // TODO: delete after segmentation test
      if (state.method === '/form' && +state.additionalParams.provider === 2) {
        fields = ['interested_in_products', ...fields]
      }

      if (res.display === 'form' || res.display === 'confirm_email') {
        dispatch('processNextFields', {
          fields: fields,
          incr: incr
        })
      } else if (res.display === 'iframe') {
        dispatch('successRedirectPrepare', 'API')
        commit('CHANGE_PRELOADER', false)
        commit('SHOW_IFRAME', res.redirect_url)
      } else if (res.display === 'feed') {
        dispatch('successRedirectPrepare', 'Feed')
        dispatch('goToOffers', res)
      } else if (res.display === 'feed_promo') { // backend sends this response if user doesn't pass recaptcha
        dispatch('successRedirectPrepare', 'Feed')
        openLink('/landing/offers/')
      } else if (res.display === 'redirect') {
        dispatch('proceedRedirect', res)
      } else if (res.display === 'curadeuda') {
        openLink('/iframe/curadeuda')
      } else if (res.display === 'feed_manual_process') {
        if (state.additionalParams.lender_id) {
          commit('SHOW_TRANSIT_PAGE', true)
        }
        dispatch('insertOrUpdateField', {
          index: state.currentStep + incr,
          data: { name: 'feed_manual_process', isValid: true }
        })
        dispatch('nextStepPrepare', incr)
        commit('CHANGE_PRELOADER', false)
      }
      //
      // update method
      if (state.method === '/form') commit('CHANGE_METHOD', '/process')
    }
  }, (error) => {
    commit('CHANGE_PRELOADER', false)
    let err = error.response.data.errors
    if (err && err[0].validation) {
      dispatch('handleValidationError', err)
    } else if (err && (err[0].critical || err[0].verification)) {
      if (Crezu.common.getURLParameter('lead_id')) {
        // fix process flow with malformed lead_id -> to /feed
        dispatch('successRedirectPrepare', 'Feed')
        dispatch('goToOffers')
        return
      }
      console.warn('critical error')
      var varsToClear = ['auth_token', 'JWTAutocomplete', 'AuthAutocomplete', 'leadId', 'lead_id']
      for (let i in varsToClear) {
        localStorage.removeItem(varsToClear[i])
      }
      window.onbeforeunload = null
      window.location.reload()
    }
  })
}

export const updateIsSentFieldsFlag = function ({ commit, state, dispatch, getters }, sendedFields) {
  let temp = state.history
  for (let i in temp) {
    if (sendedFields.indexOf(temp[i].name) > -1) temp[i].isSent = true
  }
  commit('CHANGE_HISTORY', temp)
}

export const handleValidationError = function ({ commit, state, dispatch, getters }, err) {
  let invalidFields = Array.isArray(err[0].validation) ? err[0].validation : [err[0].validation]
  const isMXReferencePhone = state.additionalParams.country === 2 && invalidFields.length === 1 && invalidFields[0] === 'reference_phone'
  if (isMXReferencePhone) {
    commit('CHANGE_STEP', state.currentStep + 2)
  }
  for (let i in invalidFields) {
    const invalidFieldName = invalidFields[i]
    const invalidFieldValue = getters.getFieldValue(invalidFieldName)
    dispatch('insertOrUpdateField', {
      index: state.currentStep + +i,
      data: {
        name: invalidFieldName,
        showError: true,
        isValid: false,
        isSent: false,
        invalidValues: [invalidFieldValue],
        field: getters.getFieldInfoByName(invalidFieldName)
      }
    })
    try {
      dispatch('sendCrezuEvent', { id: 5, data: {
          sub4: 'fieldInvalid',
          sub5: invalidFieldName,
          sub6: invalidFieldValue,
          sub7: 'back'
        }
      })

      if (invalidFieldName === 'confirm') {
        // TODO: delete moneyman additional
        dispatch('sendCrezuEvent', { id: 24, data: { sub2: 'confirm', sub3: 'confirm_validation' } })
        handleConfirmError(commit)
      }
    } catch (e) {
      console.log(e)
    }
  }
  // TODO: test if everything is ok
  // commit('CHANGE_STEP', state.currentStep + 1 - invalidFields.length)
  if (isMXReferencePhone) {
    commit('CHANGE_STEP', state.currentStep - 2)
  }
  commit('CHANGE_STEP', state.currentStep + 1)
}

export const setEnv = function({ commit, state }) {
  const isDev = Crezu.common.getURLParameter('is_dev')
  const customBackendUrl = Crezu.common.getURLParameter('custom_backend_url')
  commit('UPDATE_ENV', { isDev, customBackendUrl })
}

export const getConfig = function ({ commit, state, dispatch, getters }, url) {
  return new Promise((resolve, reject) => {
    axios({
      method: 'GET',
      url: url,
      headers: {'Content-Type': 'application/json'}
    }).then((response) => {
      const config = response.data

      // custom params rewriting
      if (window.customConfigParamsGF) {
        for (let i in window.customConfigParamsGF) {
          config.params[i] = window.customConfigParamsGF[i]
        }
      }
      commit('CHANGE_CONFIG', config)
      commit('CHANGE_FIELDS_ORDERING', state.config.main_fields.sort((a, b) => ((a.order < b.order) ? -1 : (a.order > b.order) ? 1 : 0)).map(x => x.name))

      if (config.params && config.params.progress_bar && config.params.progress_bar.step) {
        commit('CHANGE_STEP_LABEL', config.params.progress_bar.step)
      } else {
        commit('CHANGE_STEP_LABEL', 'Paso')
      }

      const leadId = Crezu.common.getURLParameter('lead_id')
      const confirmEmail = Crezu.common.getURLParameter('confirm_email')
      if (leadId && confirmEmail) {
        commit('CHANGE_FLOW', 'confirm')
        commit('CHANGE_HISTORY', {
          '0': {
            name: 'confirm_email',
            value: confirmEmail,
            isValid: true,
            field: {
              name: '',
              'game-type': 'preloader'
            }
          }
        })
        commit('CHANGE_METHOD', '/process')
        Vue.prototype.$cookie.delete('has_declined_confirm_email')
        commit('CHANGE_ADDITIONAL_PARAMS', { lead_id: leadId })
        localStorage.removeItem('auth_token')
      } else if (leadId && !confirmEmail) {
        commit('CHANGE_FLOW', 'toProcess')
        commit('CHANGE_HISTORY', {
          '0': {
            name: '',
            value: '',
            isValid: true,
            skip: true,
            field: {
              'game-type': ''
            }
          }
        })
        if (state.additionalParams.country === 14) {
          console.log('push loan_sum step')
          commit('CHANGE_FLOW', 'agreementsToProcess')
          commit('CHANGE_HISTORY', {
            '0': {
              name: 'loan_sum_repeat',
              value: '',
              isValid: true,
              field: getters.getFieldInfoByName('loan_sum_repeat')
            }
          })
          commit('SHOW_AUTH_TEXT', true)
        }
        commit('CHANGE_METHOD', '/process')
        commit('CHANGE_ADDITIONAL_PARAMS', { lead_id: leadId })
        if (Crezu.common.getURLParameter('f_l')) window.sendFLOnce = true
        localStorage.removeItem('auth_token')
      } else {
        let history = config.params.history
        if (window.showHiddenFields) {
          for (let i in history) {
            if (window.showHiddenFields.includes(history[i].name)) history[i].skip = false
          }
        }
        if (window.hideFields) {
          for (let i in history) {
            if (window.hideFields.includes(history[i].name)) history[i].skip = true
          }
        }
        commit('CHANGE_HISTORY', history)
        commit('CHANGE_AUTH_HISTORY', config.params.authHistory)
        dispatch('updateDataFromFirstStep')
      }

      // disable auth
      if (state.config.params.gameAuthDisabled) localStorage.removeItem('auth_token')

      commit('CHANGE_STEP', 0)
      if (config.params.is_terms_accepted) {
        commit('CHANGE_ADDITIONAL_PARAMS', {is_terms_accepted: 'on'})
      }
      setTimeout(() => {
        dispatch('pushFBEvent', {
          track: 'track',
          event: 'ViewContent',
          data: {content_name: 'Reg'}
        })
        dispatch('pushGAEvent', 'Reg')
      }, 1000)
      resolve()
    }, (response) => {
      reject(response)
      console.log('error:', response)
    })
  })
}

export const updateDataFromFirstStep = function ({ commit, state, dispatch, getters }) {
  let defaultLoanSum = 300
  let defaultLoanPeriod = 30
  if ([4, 5].indexOf(+state.additionalParams.country) > -1) defaultLoanPeriod = 1
  const dataFromFirstStep = localStorage.getItem('dataFromFirstStep') || '{}'
  const savedPhone = JSON.parse(dataFromFirstStep).phone
  const savedEmail = JSON.parse(dataFromFirstStep).email
  const savedAmount = JSON.parse(dataFromFirstStep).amount
  const savedPeriod = JSON.parse(dataFromFirstStep).period
  for (const i in state.config.main_fields) {
    if (state.config.main_fields[i].name === 'loan_sum') {
      const shortcuts = state.config.main_fields[i].shortcuts
      if (shortcuts) defaultLoanSum = shortcuts[shortcuts.length - 1]
    }
  }

  const updateFields = function (temp) {
    for (const i in temp) {
      if (temp[i].name === 'loan_sum') {
        temp[i].value = Crezu.common.getURLParameter('amount') || Crezu.common.getURLParameter('loan_sum') || savedAmount || defaultLoanSum
        localStorage.setItem('loan_sum', temp[i].value)
      } else if (temp[i].name === 'loan_period') {
        temp[i].value = Crezu.common.getURLParameter('days') || Crezu.common.getURLParameter('loan_period') || savedPeriod || defaultLoanPeriod
        localStorage.setItem('loan_period', temp[i].value)
      } else if (temp[i].name === 'phone') {
        if (savedPhone) {
          temp[i].value = savedPhone.split(' ').join('')
          temp[i].isValid = true
        }
      } else if (temp[i].name === 'email') {
        if (savedEmail) temp[i].value = savedEmail
      }
    }
    return temp
  }

  let history = state.history
  let authHistory = state.authHistory
  commit('CHANGE_HISTORY', updateFields(history))
  commit('CHANGE_AUTH_HISTORY', updateFields(authHistory))
}

export const getFingerprint = function ({ commit, state, getters, dispatch }) {
  const authToken = localStorage.getItem('auth_token')
  let getAuthAutocomplete = () => {
    let dtNow = Date.now() / 1000 | 0
    let lsData = localStorage.getItem('authAutocomplete')
    if (lsData) {
      try {
        let result = JSON.parse(lsData)
        if (dtNow - result.timestamp < 60) { return result } else { localStorage.removeItem('authAutocomplete') }
      } catch (e) {}
    }
    return null
  }
  const authAutocomplete = getAuthAutocomplete()
  let fingerprintReady = (fingerprint) => {
    localStorage.setItem('fingerprint', fingerprint)
    commit('CHANGE_ADDITIONAL_PARAMS', { fingerprint })
    if (authAutocomplete) {
      // Simple Auth
      commit('CHANGE_FLOW', 'simpleAuth')
      dispatch('autocompleteFieldsWithData', authAutocomplete)
    } else if (authToken) {
      let formData = new FormData()
      for (let i in state.additionalParams) {
        if (i !== 'lead_id') formData.set(i, state.additionalParams[i])
      }
      formData.set('loan_sum', getters.getFieldValue('loan_sum'))
      formData.set('loan_period', getters.getFieldValue('loan_period'))
      axios({
        method: 'POST',
        url: state.backendUrl + '/check-token',
        withCredentials: true,
        data: formData,
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Credentials': 'true',
          'Auth-Token': authToken
        }
      }).then((response) => {
        const customerData = response.data.data.customer || {}
        commit('CHANGE_ADDITIONAL_PARAMS', {lead_id: response.data.data.lead_id})
        commit('UPDATE_AUTOCOMPLETE', customerData)
        commit('CHANGE_LEAD_STATUS', response.data.data.lead_status)
        // JWT Auth
        commit('CHANGE_FLOW', 'JWTAuth')
        if (+state.additionalParams.country === 1) {
          dispatch('autocompleteFieldsWithJWT')
        } else {
          // FOR !Spain GO TO PROCESS (WITHOUT STEP WITH PHONE AND CHECKBOX)
          dispatch('autocompleteFieldsWithData', customerData)
        }
        // send groupRender and fieldRender for first step
        dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'groupRender', sub5: state.stepsCRO.length, sub8: state.history[state.currentStep].name } })
        dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'fieldRender', sub5: state.history[state.currentStep].name, sub8: state.history[state.currentStep].name } })
      }, (response) => {
        initWAOHA()
      })
    } else {
      initWAOHA()
    }
    function initWAOHA () { // without auth or hybrid auth (simple process)
      // send groupRender and fieldRender for first step
      dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'groupRender', sub5: state.stepsCRO.length, sub8: state.history[state.currentStep].name } })
      dispatch('sendCrezuEvent', { id: 5, data: { sub4: 'fieldRender', sub5: state.history[state.currentStep].name, sub8: state.history[state.currentStep].name } })
      const fromFirstStep = ['confirm', 'toProcess'].indexOf(state.flow) === -1
      const updateFirstField = () => {
        const fieldInfo = getters.getFieldInfoByName(state.history[0].name)
        if (fieldInfo) commit('UPDATE_FIELD', {field: fieldInfo})
        else console.error(`FIELD NAME: ${state.history[0].name} NOT IN CONFIG`)
      }
      if (window.hybridAuth && fromFirstStep) {
        commit('CHANGE_FLOW', 'hybridAuth')
        let hybridAuthHistory = {}
        for (const i in state.history) {
          const index = (state.history[i].name === 'phone') ? 0 : +i + 1
          hybridAuthHistory[index] = state.history[i]
        }
        commit('CHANGE_HISTORY', hybridAuthHistory)
        // We will init GA History later, on the next step (after sending simple-auth with phone)
        updateFirstField()
      } else {
        dispatch('initGAHistory', false)
        updateFirstField()
        if (!fromFirstStep) dispatch('getDataFromBackend', +1)
      }
    }
  }
  const getFingerprint = async () => {
    // old fingerprint
    const fpPromise = FingerprintJS.load();
    const fp = await fpPromise;
    const fgDict = await fp.get();
    fingerprintReady(fgDict.visitorId)
  };
  getFingerprint()
}

export const updateFirebaseTokenWithLeadId = function ({ state }) {
  const currentToken = localStorage.getItem('sentFirebaseMessagingToken')
  const acceptedButNotGranted = currentToken === 'CONFIRMED BY USER';
  const notSubscribed = currentToken === 'CANCELLED BY USER';
  const alreadySended = localStorage.getItem('updatedFirebaseMessagingToken');
  if (currentToken && !alreadySended && !notSubscribed && !acceptedButNotGranted) {
    let formData = new FormData()
    let dictData = {
      token: currentToken,
      ga_client_id: state.additionalParams.ga_client_id,
      domain: state.additionalParams.domain,
      lead_id: state.additionalParams.lead_id,
      country: state.additionalParams.country,
      provider: state.additionalParams.provider
    }
    for (let i in dictData) {
      formData.set(i, dictData[i])
    }
    axios({
      method: 'POST',
      url: state.backendUrl + '/set-token',
      data: formData,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then((response) => {
      localStorage.setItem('updatedFirebaseMessagingToken', currentToken)
    }, (response) => {
      console.warn('update token is unsuccessfull')
    })
  }
}

export const skipConfirm = function ({ state }) {
  let formData = new FormData()
  formData.set('lead_id', state.additionalParams.lead_id)
  return axios({
      method: 'POST',
      url: state.backendUrl + '/confirm/pass',
      data: formData,
      headers: {
        'Content-Type': 'application/json'
      }
    })
}



// WEBPACK FOOTER //
// ./src/store/actions.js